<div class="kx-control col-12 col-lg-12 fix p-0">
  @if (!grid && !question.key.includes('_clmReport') && !question.key.includes('_ehc_report')) {
    <div class="art-pullable-wrapper" style="position:relative;display:inline-block;">
      <button type="button" class="btn btn-primary"
      style="background:#20a8d8" (click)="pullableButtonClick(question)">Pullable</button>
      @if (showArtPatientOptions) {
        <ul class="dropdown-menu show" style="position:absolute;top:100%;left:0;z-index:1000;min-width:200px;">
          @if (artPatientOptions.length == 0) {
            <li class="dropdown-item disabled">No patients mapped to this ART no</li>
          }
          @for (patient of artPatientOptions; track patient.uhId) {
            <li class="dropdown-item" style="cursor:pointer;" (click)="selectArtPatient(question,patient)">
              {{ patient.patient_name }} ({{ patient.uhId }})
            </li>
          }
        </ul>
      }
    </div>
  }
  <!-- {{reportData|json}} -->
  @if (!grid && (question.key.includes('_clmReport') ||  question.key.includes('_ehc_report')) && !reportData['hideLink']) {
    <span class="link">
      <a href="javascript:void(0)"
      (click)="question.action=='print'?cumulativePrint(question):openreport(question,reportData)">{{reportData['linkName']}}</a>
    </span>
  }
  @if (!selectedItemData && question.value && question.value.length > 0 && question.pullable_response_array) {
    <dhs-data-grid
      [data]="{'resource':question.value}" [fields]="question.pullable_response_array" [config]="dataGridConfig" (editEllipseClick)="gridButtonClick($event)">
    </dhs-data-grid>
  }
  @if (selectedItemData) {
  <app-chemotherapy-protocol [selectedData]="selectedItemData" [pullableView]="true"></app-chemotherapy-protocol>
  }
  <!-- set grid when add button is not present  -->
  @if (gridData && gridData[this.question.key] && grid && question.pullable_response_array) {
    <dhs-data-grid
      [data]="gridData[this.question.key]" [fields]="question.pullable_response_array" [config]="dataGridConfig">
    </dhs-data-grid>
  }
</div>